import React from 'react';

const InfoSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    className="info-svg-alg"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path
        d="M9.619,12.006 L6.38,12.006 C6.167,12.006 5.995,11.805 5.995,11.558 C5.995,11.311 6.167,11.11 6.38,11.11 L7,11 L7,8 L6.38,7.884 C6.167,7.884 5.995,7.683 5.995,7.436 C5.995,7.189 6.167,6.988 6.38,6.988 L8.894,6.988 C8.971,6.988 8.996,6.956 9.007,6.93 C9.004,6.945 9,6.959 9,7 L9,11 L9.619,11.11 C9.832,11.11 10.005,11.311 10.005,11.558 C10.005,11.805 9.832,12.006 9.619,12.006 L9.619,12.006 Z M7,4 L7.98,4 C7.987,4 7.993,3.996 8,3.996 C8.007,3.996 8.013,4 8.02,4 L9,4 L9,4.94 C9.001,4.962 9.012,4.98 9.012,5.001 C9.012,5.023 9.001,5.041 9,5.062 L9,6 L8.033,6 C8.021,6.001 8.011,6.007 8,6.007 C7.988,6.007 7.978,6.001 7.967,6 L7,6 L7,5.061 C6.998,5.04 6.987,5.023 6.987,5.001 C6.987,4.98 6.998,4.962 7,4.941 L7,4 Z M8,0 C3.581,0 0,3.582 0,8 C0,12.418 3.581,16 8,16 C12.418,16 16,12.418 16,8 C16,3.582 12.418,0 8,0 L8,0 Z"
        id="path-1"
      ></path>
    </defs>
    <g
      id="Web-Desktop"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Web-Desk-Claims_Details"
        transform="translate(-473.000000, -260.000000)"
      >
        <g id="Icon/Info" transform="translate(473.000000, 260.000000)">
          <mask id="mask-2" fill="white">
            <use href="#path-1"></use>
          </mask>
          <g id="Info-Icon"></g>
          <g id="↳-🎨Color" mask="url(#mask-2)" className="InfoSVG">
            <rect id="Base" x="0" y="0" width="16" height="16"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const BulbSVG = () => (
  <svg
    width="44"
    height="50"
    viewBox="0 0 44 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.1541 41.16V38.03C30.1541 37.48 29.7055 37.03 29.1572 37.03H14.8428C14.2945 37.03 13.8459 37.48 13.8459 38.03V41.16C13.8459 43.41 15.6701 45.25 17.923 45.25H26.087C28.3199 45.25 30.1541 43.41 30.1541 41.16Z"
      className="BulbSVG"
    />
    <path
      d="M17.923 47.25C17.8034 47.25 17.6837 47.25 17.5741 47.23C17.6837 48.77 18.9696 50 20.5347 50H23.4753C25.0403 50 26.3262 48.77 26.4359 47.23C26.3262 47.25 26.2066 47.25 26.087 47.25H17.923Z"
      className="BulbSVG"
    />
    <path
      d="M20.9932 1V4.87C20.9932 5.42 21.4418 5.87 21.99 5.87C22.5482 5.87 22.9869 5.42 22.9869 4.87V1C22.9869 0.45 22.5482 0 21.99 0C21.4517 0 20.9932 0.45 20.9932 1Z"
      className="BulbSVG"
    />
    <path
      d="M31.4898 11.42C28.4794 8.72 24.4422 7.43 20.3851 7.88C14.0453 8.58 8.80199 13.68 7.91481 19.99C7.81513 20.67 7.77525 21.35 7.77525 22.02C7.77525 26.16 9.53964 30.11 12.6896 32.85C13.4372 33.5 14.0652 34.24 14.5736 35.05C14.6633 35.03 14.7531 35.03 14.8428 35.03H29.1672C29.2569 35.03 29.3466 35.03 29.4363 35.05C29.9447 34.23 30.5827 33.49 31.3303 32.84C34.4504 30.13 36.2347 26.2 36.2347 22.06C36.2347 18.01 34.5002 14.13 31.4898 11.42Z"
      className="BulbSVG"
    />
    <path
      d="M36.135 6.45998L33.4037 9.19998C33.0149 9.58998 33.0149 10.22 33.4037 10.61C33.6031 10.81 33.8523 10.91 34.1115 10.91C34.3706 10.91 34.6198 10.81 34.8192 10.61L37.5505 7.86998C37.9393 7.47998 37.9393 6.84998 37.5505 6.45998C37.1717 6.06998 36.5337 6.06998 36.135 6.45998Z"
      className="BulbSVG"
    />
    <path
      d="M9.18079 10.61C9.38015 10.81 9.62936 10.91 9.88854 10.91C10.1377 10.91 10.3969 10.81 10.5863 10.61C10.985 10.22 10.985 9.58998 10.5863 9.19998L7.86497 6.45998C7.47621 6.06998 6.83824 6.06998 6.44948 6.45998C6.06071 6.84998 6.06071 7.47998 6.44948 7.86998L9.18079 10.61Z"
      className="BulbSVG"
    />
    <path
      d="M43.0032 21.06H39.1355C38.5872 21.06 38.1386 21.51 38.1386 22.06C38.1386 22.61 38.5872 23.06 39.1355 23.06H43.0032C43.5514 23.06 44 22.61 44 22.06C44 21.51 43.5415 21.06 43.0032 21.06Z"
      className="BulbSVG"
    />
    <path
      d="M34.8192 33.51C34.4304 33.12 33.7925 33.12 33.4037 33.51C33.0149 33.9 33.0149 34.53 33.4037 34.92L36.135 37.66C36.3344 37.86 36.5836 37.96 36.8428 37.96C37.092 37.96 37.3511 37.86 37.5505 37.66C37.9393 37.27 37.9393 36.64 37.5505 36.25L34.8192 33.51Z"
      className="BulbSVG"
    />
    <path
      d="M10.5764 33.51C10.1876 33.12 9.55958 33.12 9.17082 33.51L6.43951 36.25C6.05075 36.64 6.05075 37.27 6.43951 37.66C6.63888 37.86 6.88809 37.96 7.14726 37.96C7.39647 37.96 7.65564 37.86 7.85501 37.66L10.5764 34.92C10.9851 34.53 10.9851 33.9 10.5764 33.51Z"
      className="BulbSVG"
    />
    <path
      d="M4.85455 21.06H0.996829C0.448573 21.06 0 21.51 0 22.06C0 22.61 0.448573 23.06 0.996829 23.06H4.85455C5.41278 23.06 5.85138 22.61 5.85138 22.06C5.85138 21.51 5.41278 21.06 4.85455 21.06Z"
      className="BulbSVG"
    />
  </svg>
);

const PDFSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4138 8.29314C10.4813 8.23189 10.5369 8.13127 10.58 7.99127C10.6231 7.85127 10.6444 7.66002 10.6444 7.41752C10.6444 7.17502 10.6231 6.98939 10.58 6.85939C10.5375 6.73002 10.4775 6.62877 10.4 6.55689C10.3231 6.48377 10.2256 6.43502 10.1075 6.40939C10.0194 6.38939 9.84625 6.37939 9.58813 6.37939H9.30375V8.45377H9.77563C9.9525 8.45377 10.0794 8.44314 10.1581 8.42314C10.2613 8.39752 10.3463 8.35377 10.4138 8.29314Z"
      className="pdf-svg"
    />
    <path
      d="M14.5238 1H2V21H17.625V4.10125L14.5238 1ZM11.8375 5.84937H13.985V6.37938H12.47V7.12125H13.7775V7.65125H12.47V8.98187H11.8375V5.84937ZM8.67188 5.84937H9.8275C10.0881 5.84937 10.2869 5.86938 10.4238 5.90938C10.6075 5.96375 10.765 6.05938 10.8962 6.19813C11.0269 6.33625 11.1269 6.505 11.1956 6.70562C11.2644 6.90625 11.2981 7.1525 11.2981 7.44625C11.2981 7.70375 11.2656 7.92625 11.2019 8.1125C11.1237 8.34 11.0119 8.52438 10.8669 8.66563C10.7569 8.7725 10.6087 8.85625 10.4225 8.91562C10.2831 8.95937 10.0962 8.98125 9.8625 8.98125H8.6725V5.84937H8.67188ZM5.75562 5.84937H6.77063C7.155 5.84937 7.40563 5.865 7.5225 5.89625C7.70188 5.94313 7.85188 6.045 7.97313 6.2025C8.09438 6.36 8.155 6.56312 8.155 6.81312C8.155 7.005 8.12 7.16625 8.05062 7.2975C7.98125 7.42875 7.8925 7.53125 7.785 7.60625C7.6775 7.68062 7.56812 7.73 7.45687 7.75438C7.30562 7.78438 7.0875 7.79875 6.80125 7.79875H6.38875V8.98063H5.75562V5.84937ZM14.4956 16.6506H5.12937V16.0256H14.4956V16.6506V16.6506ZM14.4956 14.4375H5.12937V13.8125H14.4956V14.4375V14.4375Z"
      className="pdf-svg"
    />
    <path
      d="M7.23437 7.21816C7.31812 7.18566 7.38437 7.13441 7.43187 7.06441C7.48 6.99503 7.50375 6.91378 7.50375 6.82128C7.50375 6.70691 7.47 6.61316 7.40312 6.53941C7.33625 6.46503 7.25125 6.41878 7.14875 6.40003C7.07312 6.38628 6.92187 6.37878 6.69375 6.37878H6.38812V7.26753H6.73437C6.98375 7.26753 7.15 7.25128 7.23437 7.21816Z"
      className="pdf-svg"
    />
  </svg>
);

export { InfoSVG, BulbSVG, PDFSVG };
